module.exports = __webpack_public_path__ + "img/Mentor_Graphics_Logo.svg.c12aef1a.png";